import { render } from "./adverseEvent.vue?vue&type=template&id=2d23fcfb&scoped=true"
import script from "./adverseEvent.vue?vue&type=script&lang=js"
export * from "./adverseEvent.vue?vue&type=script&lang=js"

import "./adverseEvent.vue?vue&type=style&index=0&id=2d23fcfb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d23fcfb"]])

export default __exports__